import {makeStyles} from '@mui/styles';
import {alpha} from "@mui/material";

const useStyles = makeStyles((theme, props = {}) => ({

    '& .MuiPaper-root.MuiPaper-elevation': {
        backgroundColor: "red"
    },

    toolbarMenu: {
      //fontSize: 14,
      //  backgroundColor: "red"

        "& .MuiTablePagination-root": {

        },

        "@media screen and (max-width: 480px)": {
            justifyContent: "center",

            "& nav.MuiPagination-root": {
                maxHeight: 26,
            }
        },

        '& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked': {
            color: theme.palette.mainButton.blue
        },
    },


    menuItemProps: {
        '& .MuiButtonBase-root': {
            fontSize: 12
        },

    },

    showHideMenuItems: {
        "@media screen and (max-width: 768px)": {
            display: "none"
        }
    },

    materialReactTableCustom: {
        overflow: "auto",
        width: "100%",

        '& .MuiFormControl-root .MuiInputBase-root.MuiInput-root': {
            fontSize: 12
        },

        '& .MuiPaper-root': {
            '&:first-child': {}
        },

        '& .MuiBox-root': {
            display: "flex",
            alignItems: "center",
            '& .Mui-ToolbarDropZone' : {
                '&+.MuiBox-root': {
                    position: "static",
                    width: "auto",
                    order: 1,
                }
            },
            '& .MuiTablePagination-root': {
                justifySelf: "flex-start",
                display: "flex",
                flexDirection: "row-reverse",
                gap: 32,
                marginRight: 32,
                marginTop: 14,

                "@media screen and (max-width: 768px)": {
                    gap: 16,
                    marginRight: 16,
                    marginTop: 8,
                },

                '& .MuiFormLabel-root': {
                    color: theme.palette.mainButton.dark,

                    "@media screen and (max-width: 768px)": {
                        fontSize: 14
                    },

                    "@media screen and (max-width: 480px)": {
                        fontSize: 12
                    }
                },

                "@media screen and (max-width: 480px)": {
                    flexDirection: "column-reverse",
                    marginTop: 2,
                    gap: 2,

                    '& .MuiPagination-ul': {
                        flexWrap: "nowrap"
                    },

                    /*'& .MuiFormLabel-root': {
                        fontSize: 12
                    },*/

                    '& .MuiInputBase-root': {
                        fontSize: 14
                    },
                }
            },

            '& .MuiTableBody-root': {
                overflowY: "auto"
            }
        },
        '& .MuiTableContainer-root': {
            maxHeight: props => props.maxHeightContainer || "78vh",

            '& + *': {
                // пустая секция после таблицы !!!
                display: "none"
            },

        },
        '& .Mui-TableHeadCell-Content-Wrapper': {
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1.56
        },
        '& .MuiTableCell-root': {
            fontSize: 10,
            lineHeight: 1.3,
            minWidth: props => props.tableCell?.minWidth || "none",

            '&:first-child': {
                minWidth: "1%"
            },
            '&[itemprop="0"]': {
                paddingLeft: 0
            },
            '&[itemprop="1"]': {
                paddingLeft: 8
            },
            '&[itemprop="2"]': {
                paddingLeft: 16
            },
            '&[itemprop="3"]': {
                paddingLeft: 24
            },
            '&[itemprop="4"]': {
                paddingLeft: 32
            },
            '&[itemprop="5"]': {
                paddingLeft: 40
            },
        },
        '& .MuiTableCell-body .MuiButtonBase-root': {
            padding: 0,
            minWidth: "auto",
        },

    },
    childrenRow: {
        '& .MuiTableCell-root:first-child': {
            //paddingLeft: 8
        }
    },

    fieldN: {
       /* width: '3rem',
        minWidth: 'max-content',
        padding: '1rem 0',*/
    },

    parentRow: {
        backgroundColor: alpha(`${theme.palette.mainButton.blue}`, .15)+ '!important',
        '&[itemprop="1"]': {
            backgroundColor: alpha(`${theme.palette.mainButton.blue}`, .10)+ '!important',
        },
        '&[itemprop="2"]': {
            backgroundColor: alpha(`${theme.palette.mainButton.blue}`, .05)+ '!important',
        },
        '&[itemprop="3"]': {
            backgroundColor: alpha(`${theme.palette.mainButton.blue}`, .03)+ '!important',
        },
        '&[itemprop="4"]': {
            backgroundColor: alpha(`${theme.palette.mainButton.blue}`, .02)+ '!important',
        },
        '&[itemprop="5"]': {
            backgroundColor: alpha(`${theme.palette.mainButton.blue}`, .01)+ '!important',
        },
    }
}))

export default useStyles;
